/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { formatCurrency } from '../../shared/helper-utils/appUtils';

function FareSummary({
  fareSummary,
  passengers,
  selectedFare,
  journeyType,
  domint,
}) {
  const [hasFareSummary, setHasFareSummary] = useState(false);
  const fareSummaryRef = useRef({});
  const getFareSummary = () => {
    if (journeyType === 'oneway' || domint === 'international') {
      const { onward: onwardFare } = selectedFare;
      const totalFareQuote = onwardFare.totalfq;
      fareSummaryRef.current = { totalFareQuote };
      fareSummaryRef.current.adultBaseFare = onwardFare.adultbasefare;
      fareSummaryRef.current.adultTax = onwardFare.adulttax;
    }
    setHasFareSummary(true);
  };
  useEffect(() => {
    getFareSummary();
  }, []);
  return (
    hasFareSummary && (
      <div className="table-body fare-summary">
        <div className="mb-3 fw-500">
          <FormattedMessage id="fare_breakdown" />
        </div>
        <div className="mb-3">
          {passengers.numAdults > 0 && (
            <div className="fare-summary_container">
              <div className="fare-summary__row">
                <span className="fare-summary__row_label me-2">
                  <FormattedMessage id="adult_base_fare" />
                </span>
                <span className="fare-summary__row_value ">
                  {formatCurrency(fareSummary.adultBaseFare)}
                </span>
              </div>
              <div className="fare-summary__row">
                <span className="fare-summary__row_label me-2">
                  <FormattedMessage id="ot_tax" />
                </span>
                <span className="fare-summary__row_value ">
                  {formatCurrency(
                    fareSummary.adultTotalTax -
                      fareSummary.adultKValue -
                      fareSummary.adultFuelCharge,
                  )}
                </span>
              </div>
              <div className="fare-summary__row">
                <span className="fare-summary__row_label me-2">
                  <FormattedMessage id="k3_airlinegst" />
                </span>
                <span className="fare-summary__row_value ">
                  {formatCurrency(fareSummary.adultKValue)}
                </span>
              </div>
              <div className="fare-summary__row">
                <span className="fare-summary__row_label me-2">
                  <FormattedMessage id="fuel_charges" />
                </span>
                <span className="fare-summary__row_value ">
                  {formatCurrency(fareSummary.adultFuelCharge)}
                </span>
              </div>
              <div className="fare-summary__row">
                <span className="fare-summary__row_label me-2">
                  <FormattedMessage id="total" />
                </span>
                <span className="fare-summary__row_value ">
                  {formatCurrency(
                    fareSummary.adultBaseFare + fareSummary.adultTotalTax,
                  )}
                </span>
              </div>
            </div>
          )}
          {passengers.numChilds > 0 && (
            <div className="fare-summary_container">
              <div className="fare-summary__row">
                <span className="fare-summary__row_label">
                  <FormattedMessage id="child_basefare" />
                </span>
                <span className="fare-summary__row_value">
                  {formatCurrency(fareSummary.childBaseFare)}
                </span>
              </div>
              <div className="fare-summary__row">
                <span className="fare-summary__row_label">
                  <FormattedMessage id="ot_tax" />
                </span>
                <span className="fare-summary__row_value">
                  {formatCurrency(
                    fareSummary.childTotalTax - fareSummary.childFuelCharge,
                  )}
                </span>
              </div>
              <div className="fare-summary__row">
                <span className="fare-summary__row_label">
                  <FormattedMessage id="fuel_charges" />
                </span>
                <span className="fare-summary__row_value">
                  {formatCurrency(fareSummary.childFuelCharge)}
                </span>
              </div>
              <div className="fare-summary__row">
                <span className="fare-summary__row_label">
                  <FormattedMessage id="total" />
                </span>
                <span className="fare-summary__row_value">
                  {formatCurrency(
                    fareSummary.childBaseFare + fareSummary.childTotalTax,
                  )}
                </span>
              </div>
            </div>
          )}
          {passengers.numInfants > 0 && (
            <div className="fare-summary_container">
              <div className="fare-summary__row">
                <span className="fare-summary__row_label">
                  <FormattedMessage id="infant_basefare" />
                </span>
                <span className="fare-summary__row_value">
                  {formatCurrency(fareSummary.infantBaseFare)}
                </span>
              </div>
              <div className="fare-summary__row">
                <span className="fare-summary__row_label">
                  <FormattedMessage id="ot_tax" />
                </span>
                <span className="fare-summary__row_value">
                  {formatCurrency(
                    fareSummary.infantTotalTax - fareSummary.infantFuelCharge,
                  )}
                </span>
              </div>
              <div className="fare-summary__row">
                <span className="fare-summary__row_label">
                  <FormattedMessage id="fuel_charges" />
                </span>
                <span className="fare-summary__row_value">
                  {formatCurrency(fareSummary.infantFuelCharge)}
                </span>
              </div>
              <div className="fare-summary__row">
                <span className="fare-summary__row_label">
                  <FormattedMessage id="total" />
                </span>
                <span className="fare-summary__row_value">
                  {formatCurrency(
                    fareSummary.infantBaseFare + fareSummary.infantTotalTax,
                  )}
                </span>
              </div>
            </div>
          )}
        </div>
        <div className="fare-summary_container">
          {passengers.numAdults > 0 && (
            <div className="fare-summary__row">
              <span className="fare-summary__row_label">
                <FormattedMessage id="adult" /> * {passengers.numAdults}
              </span>
              <span className="fare-summary__row_value">
                {formatCurrency(
                  passengers.numAdults *
                    (fareSummary.adultBaseFare + fareSummary.adultTotalTax),
                )}
              </span>
            </div>
          )}
          {passengers.numChilds > 0 && (
            <div className="fare-summary__row">
              <span className="fare-summary__row_label">
                <FormattedMessage id="child" /> * {passengers.numChilds}
              </span>
              <span className="fare-summary__row_value">
                {formatCurrency(
                  passengers.numChilds *
                    (fareSummary.childBaseFare + fareSummary.childTotalTax),
                )}
              </span>
            </div>
          )}
          {passengers.numInfants > 0 && (
            <div className="fare-summary__row">
              <span className="fare-summary__row_label">
                <FormattedMessage id="infant" /> * {passengers.numInfants}
              </span>
              <span className="fare-summary__row_value">
                {formatCurrency(
                  passengers.numInfants *
                    (fareSummary.infantBaseFare + fareSummary.infantTotalTax),
                )}
              </span>
            </div>
          )}
          <div className="fare-summary__row">
            <span className="fare-summary__row_label">
              <FormattedMessage id="Handling Charges" />
              (+)
            </span>
            <span className="fare-summary__row_value">
              {formatCurrency(fareSummary.handlingCharges)}
            </span>
          </div>
          <div className="fare-summary__row">
            <span className="fare-summary__row_label">
              <FormattedMessage id="gst" />
            </span>
            <span className="fare-summary__row_value">
              {formatCurrency(fareSummary.gst)}
            </span>
          </div>
          <div className="fare-summary__row">
            <span className="fare-summary__row_label">
              <FormattedMessage id="mark_up" />
            </span>
            <span className="fare-summary__row_value">
              {formatCurrency(fareSummary.markUp)}
            </span>
          </div>
          {(fareSummary.hasSeat ||
            fareSummary.hasMeal ||
            fareSummary.hasBaggage) && (
            <div className="mb-3 fw-500">
              <FormattedMessage id="extras" />
            </div>
          )}
          {fareSummary.hasSeat && (
            <div className="fare-summary__row">
              <span className="fare-summary__row_label">
                <FormattedMessage id="seats_total" />
              </span>
              <span className="fare-summary__row_value">
                {formatCurrency(fareSummary.seatPrice)}
              </span>
            </div>
          )}
          {fareSummary.hasMeal && (
            <div className="fare-summary__row">
              <span className="fare-summary__row_label">
                <FormattedMessage id="meal_total" />
              </span>
              <span className="fare-summary__row_value">
                {formatCurrency(fareSummary.mealPrice)}
              </span>
            </div>
          )}
          {fareSummary.hasBaggage && (
            <div className="fare-summary__row">
              <span className="fare-summary__row_label">
                <FormattedMessage id="baggage_total" />
              </span>
              <span className="fare-summary__row_value">
                {formatCurrency(fareSummary.baggagePrice)}
              </span>
            </div>
          )}
          {fareSummary.hasSpecialSsr && (
            <div className="fare-summary__row">
              <span className="fare-summary__row_label">
                <FormattedMessage id="special_ssr_total" />
              </span>
              <span className="fare-summary__row_value">
                {formatCurrency(fareSummary.specialSsrPrice)}
              </span>
            </div>
          )}
          <div className="fare-summary__row">
            <span className="fare-summary__row_label">
              <FormattedMessage id="total_net" />
            </span>
            <span className="fare-summary__row_value">
              {formatCurrency(fareSummary.totalNet)}
            </span>
          </div>
        </div>

        <div className="fare-summary__row">
          <span className="fare-summary__row_label me-2">
            <FormattedMessage id="total_fare_quote" />
          </span>
          <span className="fare-summary__row_value">
            {formatCurrency(fareSummary.totalFare)}
          </span>
        </div>
      </div>
    )
  );
}

FareSummary.defaultProps = {
  domint: 'domestic',
};

FareSummary.propTypes = {
  fareSummary: PropTypes.object.isRequired,
  passengers: PropTypes.object.isRequired,
  selectedFare: PropTypes.any.isRequired,
  journeyType: PropTypes.string.isRequired,
  domint: PropTypes.string,
};

export default FareSummary;
